import { UserInfo } from '@common/react/user';

export const isEnabled = () => false;

export const initDatadog = () => {};

/* eslint-disable @typescript-eslint/no-unused-vars */
export const setDatadogUser = (
    user: Pick<UserInfo, 'id' | 'firstName' | 'lastName' | 'email'>
) => {};
/* eslint-enable @typescript-eslint/no-unused-vars */
